import React, { SetStateAction, useRef, useState } from 'react';
import { Accordion } from '@uk-source-web/accordion';
import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@uk-source-web/collapsible-container';
import { Paragraph } from '@uk-source-web/paragraph';
import { Icon } from '@uk-source-web/icon';
import {
  TenantPortingItemHeading,
  TenantPortingItemInfo,
} from './TenantPortingItem.styles';
import { Heading } from '@uk-source-web/heading';
import TenantPortingNextSteps from '../TenantPortingNextSteps/TenantPortingNextStep';
import { TenantPortingItemProps } from './TenantPortingItem.types';
import { getImage, getSrc } from 'gatsby-plugin-image';
import Image from '@legacy-vfuk/core-image';
import { CalloutMessage, CompletedPurchaseCallout } from '../../OrderCompletedPurchase/OrderCompletedPurchase.styles';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { OrderCompletedPurchaseProps } from '../../OrderCompletedPurchase/OrderCompletedPurchase.types';

const TenantPortingItem = ({
  queryParams,
  calloutMessages,
  calloutMessageNonMsft,
  initiallyOpenIds = [],
  ...item
}: TenantPortingItemProps) => {


  const orderId = queryParams?.get('id') || 'teste@email.com';
  const userEmail = queryParams?.get('email') || '0800';
  const rrLink = queryParams?.get('rrLink') || '';



  const formatMainMessage = (msg: OrderCompletedPurchaseProps['mainMessage']) => {
    let message = msg.raw;
    message = message.replace('${orderId}', orderId);
    message = message.replace('${userEmail}', userEmail);

    return documentToReactComponents(JSON.parse(message));
  };
  const thumbnailIconSrc =
    typeof item.thumbnailIcon == 'string'
      ? item.thumbnailIcon
      : getSrc(item.thumbnailIcon) ?? getImage(item.thumbnailIcon)?.placeholder?.fallback;

  const isMicrosoftProduct = item.msftProduct;
 

  return (
    <div>
      <Accordion
        id="accordion-id"
        dataSelectorPrefix="accordion"
        dataAttributes={{
          'data-test-id': 'accordion',
        }}
        initiallyOpenIds={initiallyOpenIds as [] | [string]}
      >
        {[
          <CollapsibleContainer id={item.id}>
            {isMicrosoftProduct ? (
              <TenantPortingItemInfo>
                <Icon name="warning" group="hifiLight" />
                <Paragraph>Microsoft requires you to finish setting up your subscription.</Paragraph>
              </TenantPortingItemInfo>
            ) : (
              <></>
            )}

            <TenantPortingItemHeading>
              <Image alt="image" sm={{ src: thumbnailIconSrc ?? '' }} />
              <CollapsibleContainerHeader>
                {' '}
                <Heading level={4} weight={3} text={item?.dxlInformation?.name ?? item?.name} />
              </CollapsibleContainerHeader>
            </TenantPortingItemHeading>
            <CollapsibleContainerBody>
              {isMicrosoftProduct &&
                calloutMessages?.map(item => (
                  <TenantPortingNextSteps
                    id={''}
                    key={item.name}
                    __typename={'ContentfulSectionTenantPortingSteps'}
                    name={item.name}
                    messageHeading={item.messageHeading}
                    adminMessage={item.adminMessage}
                    notAdminMessage={item.notAdminMessage}
                    adminTenantPortingItems={item.adminTenantPortingItems}
                    notAdminTenantPortingItems={item.notAdminTenantPortingItems}
                    accesssButton={item.accesssButton}
                    copyLinkButton={item.copyLinkButton}
                    rrLink={rrLink}
                  />
                ))}

              {!isMicrosoftProduct && Array.isArray(calloutMessageNonMsft) && calloutMessageNonMsft.length > 0 && (
                <>
                  {calloutMessageNonMsft.map(callout => (
                    <>
                      <Heading level={4} weight={3}>
                        {callout.messageHeading}
                      </Heading>
                      <CompletedPurchaseCallout>
                        {callout.purchaseStatus === 'success' ? (
                          <Icon name={'tick-circle'} group="system" />
                        ) : (
                          <Icon name={'error'} group="state" />
                        )}
                        <CalloutMessage>{formatMainMessage(callout.mainMessage)}</CalloutMessage>
                      </CompletedPurchaseCallout>
                      {callout.calloutMessages?.map(callout => (
                        <CompletedPurchaseCallout key={callout.id}>
                          {callout?.icon && <Icon name={callout.icon} group="system" size={3} />}
                          <CalloutMessage>{documentToReactComponents(JSON.parse(callout.message.raw))}</CalloutMessage>
                        </CompletedPurchaseCallout>
                      ))}
                    </>
                  ))}
                </>
              )}
            </CollapsibleContainerBody>
          </CollapsibleContainer>,
        ]}
      </Accordion>
    </div>
  );
};

export default TenantPortingItem;
